<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.billing')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.billing.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
    </div>

    <div table>
      <p-table
        [value]="packages"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="billing-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
          <tr>
              <th>{{ t('common.labels.name') }}</th>
              <th>{{ t('common.labels.amount') }}</th>
              <th>{{ t('common.labels.used') }}</th>
              <th>{{ t('common.labels.status') }}</th>
              <th>{{ t('common.labels.activated') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-package>
            <tr (click)="onOpen(package)" (keyup.enter)="onOpen(package)" [ngClass]="{inactive: !package.isActive()}" hoverOnRight="admin.billing.show" tabindex="0">
              <td><span role="link" [attr.aria-label]="package.name">{{ package.name }}</span></td>
              <td>{{ package.amount }}</td>
              <td>{{ package.used }}
                <ng-container *ngIf="package.status === 'active'">
                  <i *ngIf="(billing.depleted$ | async) === true" class="pi pi-exclamation-triangle p-ml-2 error" [pTooltip]="t('billing.messages.depleted')"></i>
                  <i *ngIf="(billing.ending$ | async) === true" class="pi pi-exclamation-triangle p-ml-2 warning" [pTooltip]="t('billing.messages.ending', { amount: (billing.remaining$ | async)})"></i>
                </ng-container>
              </td>
              <td>{{ t('common.labels.' + package.status) }}</td>
              <td>{{ package.activated_at | amDateFormat: 'DD.MM.YYYY' | dashWhenEmpty }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="5">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
